module.exports = __webpack_public_path__ + "static/media/Piscina-2.6c979500.jpg";